import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import compose from 'recompose/compose';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Grid} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { ModalHeader } from 'reactstrap';
import {Button, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { addAFNotis } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import moment from 'moment-timezone'
import IntlMessages from 'util/IntlMessages';
const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    inputRoot: {
        padding: '9px 12px',
        fontSize: 20
      },
      adornedStart: {
        padding: 0
      }
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function mapStateToProps({auth,accountsData,Projekt}) {
    const { authUser} = auth;
    const { KundSearch,Flags} = accountsData;
    const { TimeTypes, ProjectListAutoComplete} = Projekt;
    return {
        authUser,KundSearch,Flags,TimeTypes,ProjectListAutoComplete
    };
}

function mapDispatchToProps(dispatch) {
    return {
      addAFNotis: (Afid, Userid, Text) => dispatch(addAFNotis(Afid, Userid, Text)),
      dispatch
    };
}

class PopUpSkapaAFNotis extends Component {
    state={
        open:false,
        errorText: false,
        text: ''
    }
    componentDidUpdate=()=>{
        if(this.state.open !== this.props.open){
            this.setState({
                open:this.props.open
            })
        }
    }
    handleClose = () => {
      this.props.handleClose()
      this.setState({
          errorText: false,
          text: ''
      })
    }
    handleComplete = () => {
        const userid = this.props.authUser.user_id;
        const Kontoid = this.props.authUser.user_Afid;
        if(this.state.text === "") {
          this.setState({
            errorText: true,
        })
        } else {
            this.setState({
              errorText: false,
              text: ''
          })
          this.props.addAFNotis(userid, Kontoid, this.state.text)
          this.props.handleClose(false)
        }
    }
      handleChangeText = (text) => {
        this.setState({
          ...this.state,
          text: text,
          errorText: false,
      })
      }
    render() {
        const { fullScreen, classes } = this.props;
        
        return (
            <Dialog 
              onClose={this.handleClose} 
              aria-labelledby="customized-dialog-title"
              fullScreen={fullScreen}
              fullWidth={true}
              open={isUndefined(this.state.open)?false:this.state.open} 
              maxWidth={"xs"} 
              disableBackdropClick={true} 
            >
        <ModalHeader className="modal-box-header bg-primary text-white">
            Skicka  notis meddelande
            <IconButton className="text-white"
                onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers>
          <Grid container spacing={2} >
            <Grid item xs="12">
              <TextField 
                label={<IntlMessages id="Label.Message"/>}
                variant="outlined"
                size="small"
                fullWidth
                multiline
                error={this.state.errorText}
                rows={8}
                value={this.state.text}
                onChange={e => this.handleChangeText(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                <div>
                    <Button onClick={this.handleClose} variant="outlined" color="default" 
                    className="jr-btn">
                        <IntlMessages id="Cancel"/>
                    </Button>
                </div>
                <div className="ml-auto">
                  <Button
                        color="primary"
                        className="jr-btn"
                        variant="contained"
                        // disabled={
                        //     isEmpty(this.state.newKund.Orgnr) ||
                        //     this.state.newKund.Orgnr.length <8 ||
                        //     isEmpty(this.state.newKund.KundNamn)
                        // }
                        onClick={this.handleComplete}
                        >
                        <IntlMessages id="Send"/>
                        </Button>
                    </div>
                </Grid>
              </DialogActions>
          </Dialog> 
        );
    }
}

export default compose(
    withStyles(styles),
    (withMediaQuery([
        ['fullScreen', theme => theme.breakpoints.down('xs'), {
          defaultMatches: true
        }]
      ])),
    connect(mapStateToProps,mapDispatchToProps)
)(PopUpSkapaAFNotis);



